<!-- static content data from lang: past_script_details -->
<template>
    <div class="container h-100">
        <div class="py-3 h-100" v-loading="loading">
            <template v-if="errored">
                <NotFound/>
            </template>
            <template v-else-if="data">
                <b-card class="script-details">
                    <template slot="header">
                        <div class="text-center">
                            <h5 class="id">{{lang.label.header}}</h5>
                        </div>
                    </template>
                    <div class="full-detail">
                        <div class="row">
                            <div class="col-md-12">
                                <b-card class="card-box" body-class="p-0">
                                    <div class="row">
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.patientName}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.name!=''? data.name :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.dob}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.dob!=''? data.dob :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.idNumber}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.idNumber!=''? data.idNumber :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.email}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.email!=''? data.email :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.phoneNumber}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.mobile!=''? data.mobile :lang.label.nodata)}}</span>
                                        </div>
                                        <hr/>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.patientMinor}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.isMinor==0? lang.label.no :lang.label.yes)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.nameOfParent}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.parentName!=''? data.parentName :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.idOfParent}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.idNumberParent!=''? data.idNumberParent :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.medicineRequired}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.medicine!=''? data.medicine :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.specialInstruction}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.specialInstructions!=''? data.specialInstructions :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.namePharmacy}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.pharmacistName!=''? data.pharmacistName :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.emailPharmacy}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.pharmacistEmail!=''? data.pharmacistEmail :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.mobilePharmacy}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.pharmacistMobile!=''? data.pharmacistMobile :lang.label.nodata)}}</span>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group class="mb-0 btn-mt">
                                                <b-btn
                                                    type="submit"
                                                    variant="secondary"
                                                    class="w-100 mb-3"
                                                    @click="cardClicked(data)"
                                                    >{{lang.label.buttons.createScriptModal}}
                                                </b-btn>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group class="mb-0 btn-mt">
                                                <b-btn
                                                    type="submit"
                                                    variant="primary"
                                                    class="w-100"
                                                    @click="rejectRequest"
                                                    >{{lang.label.buttons.reject}}
                                                </b-btn>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </b-card>
            </template>
        </div>
        <b-modal
            id="modal-center"
            ref="reject_request"
            centered
            :title="lang.label.rejectRequest"
            hide-footer
            >
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.stop.prevent="passes(onSubmit)">
                    <b-form-group>
                        <div class="row">
                            <div class="col-12 col-md-12">
                                <label class="label-control" for="name">
                                    {{lang.label.reason}}:
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <div class="col-12 col-md-12">
                                <ValidationProvider
                                    name="reason"
                                    rules="required"
                                    v-slot="validationContext"
                                    >
                                    <b-form-textarea
                                        :state="getValidationState(validationContext)"
                                        v-model="reason"
                                        ref="prescription"
                                        type="text"
                                        :placeholder="lang.label.enterReason"
                                        rows="3"
                                        max-rows="3"
                                        ></b-form-textarea>
                                    <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.reasonRequired}}</b-form-invalid-feedback>
                                    <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                                </ValidationProvider>
                            </div>
                        </div>
                    </b-form-group>
                    <div class="mt-3">
                        <b-btn type="submit" :disabled="onSend" variant="primary" class="w-100">{{lang.label.buttons.submit}}</b-btn>
                    </div>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal id="modal-center" ref="create_script" centered hide-footer>
            <div class="share-buttons">
                <b-btn variant="primary" class="w-100"><a style="color:#FFF" target="_blank" @click="createScript(1)">{{lang.label.buttons.createScript}}</a></b-btn>
                <b-btn variant="primary" class="w-100 btn-copy" @click="createScript(2)">{{lang.label.buttons.createEScript}}</b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Vue from "vue";
    import jsondata from "../assets/json/data.json";
    import VueSilentbox from "vue-silentbox";

    Vue.use(VueSilentbox);
    import VueClipboard from 'vue-clipboard2';
    import {mapGetters} from "vuex";

    Vue.use(VueClipboard);
    var moment = require('moment'); // require
    import NotFound from "../components/NotFound.vue";

    export default {

        components: {
            NotFound
        },
        data() {
            return {
                data: {},
                mailDetails: '',
                shareUrl: '',
                reason: '',
                id: this.$route.params.id,
                lang: this.$lang.script_request_details,
                images: [],
                pdf: [],
                loading: true,
                errored: false,
                models: {
                    idNumber: "",
                    patientMinor: [],
                    parentName: "",
                    parentIDNumber: "",
                    medicineRequired: "",
                    specialInstructions: "",
                },
                onSend: false
            }
        },
        computed: {
            ...mapGetters({
                    login: "login",
                    scriptRequestDetails: "scriptRequestDetails",
            })
        },
        mounted() {
            this.data = this.scriptRequestDetails;
            this.loading = false;

        },
        methods: {
            formatAddress(address) {
                return address.replace(/\n/g, '<br/>');
            },
            scriptDetail() {
//                return 'Dear '+this.data.patientsName+', you submitted a request for a script / form to '+this.login.name+'. If you requested the document, please click this link '+'"' +this.data.shared_url +'"'+' to make payment and download the document. Thank you, '+this.login.name;
            },
            scriptDetails() {
                let subject = 'mailto:' + this.data.pEmail + '?subject=Payscript – Script / Form from ' + this.login.practiceName + ' &body=';
                let body = 'Dear ' + this.data.patientsName + ',' + '%0D%0A%0D%0A' + 'You submitted a request for a script / form to ' + this.login.practiceName + '. If you requested the document, please ' + 'OPEN ' + this.data.shared_url + ' to pay and access the document.' + '%0D%0A%0D%0A' + 'Thank you, %0D%0A' + this.login.practiceName;
                return subject + body;
            },
            formatDob(date) {
                return moment(date).format('DD/MM/YYYY');
            },
            formatScriptDate(date) {
                let format = moment(date).format('Do MMM YYYY');
                moment.locale('en', {
                    ordinal: num => {
                        const b = num % 10;
                        const output = (~~(num % 100 / 10) === 1) ? 'th' :
                                (b === 1) ? 'st' :
                                (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                        return num + '<sup>' + output + '</sup>';
                    },
                });

                return moment(date).format('Do MMM YYYY');
            },
            onCopy: function (e) {

                if (this.data.shared_url != "") {
                    return this.notifyVue('success');
                } else {
                    return this.notifyVueError('error');
                }
            },
            onError: function (e) {
                this.notifyVueError('error');
            },
            notifyVue(type = 'success') {

                this.$notify({

                    message: this.lang.label.copiedlink,
                    timeout: 5000,
                    type
                });
            },
            notifyVueError(type = 'error') {

                this.$notify({

                    message: this.lang.label.errorIncopyLink,
                    timeout: 5000,

                    type
                });
            },
            formatAddress(address) {
                if (address) {
                    return address.replace(/\n/g, '<br/>');
                }
            },
            formatPrescription(prescription) {
                if (prescription) {
                    return prescription.replace(/\n/g, '<br/>');
                }

            },
            Download(url) {
                url = this.pdf;
                document.getElementById('my_iframe').src = url;
            },
            rejectRequest() {
                this.$refs.reject_request.show();
            },
            onSubmit() {
                let self = this;
                self.loading = true;
                self.onSend = true;
                let params = {
                    "reason": this.reason,
                    "appointmentId": this.data.appointmentId
                };
                this.$store.dispatch('rejectAppointmentRequest', params).then(value => {
//					console.log('value',value);
                    self.loading = false;
                    if (value.message) {
                        self.open(value.message);
                        this.$refs.reject_request.hide();
                        self.onSend = false;
                    }
                })
            },
            open(message) {
                let self = this;
                this.$alert(message, '', {
                    confirmButtonText: 'OK',
                    callback: action => {
                        self.loading = false;
                        // self.$router.push({name:'group-request-list'})
                        console.log(this.login.token);
                        // self.$router.push({name:'past-request-list'});
                        self.$router.push({name: 'home'});
                    }
                });
            },
            getValidationState( { dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            cardClicked(patient) {
                this.patientInfo = patient;
                this.$refs.create_script.show();
                // this.$bvModal.show('modal-center');
            },
            createScript(type) {
                this.patientInfo.name = this.patientInfo.name;
                this.$store.commit('setPatientInfo', this.patientInfo);
                this.$store.commit('setFromGroupRequests', false);
                if (type == 1) {
                    this.$router.push({name: 'create-script'});
                } else {
                    this.$router.push({name: 'create-electronic-script'});
                }
            }

        }
    };
</script>
